import React from "react";
import {
  Box,
  Card,
  CardBody,
  CardFooter,
  Heading,
  Button,
  Text,
  Grid,
} from "grommet";
export const CourseList = ({ courses, selectedCourse }) => {
  

  const handleEnroll = (course) => {
    if (course.c_id === "H45ZDS") {
      window.open(
        `https://www.hpe.com/us/en/collaterals/collateral.a50013061enw.html`,
        "_blank",
      );
    } else if (course.c_id === "H45ZCS") {
      window.open(
        `https://www.hpe.com/us/en/collaterals/collateral.a50013273enw.html`,
        "_blank",
      );
    } else if (course.OEM === "morpheus") {
      window.open(
        `https://education.hpe.com/ww/en/training/portfolio/virtualization.html`,
        "_blank",
      );
    } else {
      window.open(
        `https://education.hpe.com/ww/en/training/docs/cds/${course.c_id}.pdf`,
        "_blank",
      );
    }
  };
  const handleelearningEnroll = (course) => {
    const course_code_map = {
      "HPE OneView for Compute": "H62E2AAE",
      "HPE OneView for HPE ProLiant DL/ML Servers": "H9TR9AAE",
      "HPE Synergy Administration with HPE OneView": "H0LP7AAE",
      "HPE SimpliVity System Administration": "H9TS2AAE",
    };
    const modifiedCourseId = course_code_map[course.name];

    window.open(
      `https://education.hpe.com/ww/en/training/docs/cds/${modifiedCourseId}.pdf`,
      "_blank",
    );
  };

  return (
    <Box
      // direction="row"
      // justify="center"
      // justify="start"
      gap="medium"
      pad={{ horizontal: "small", vertical: "medium" }}
      margin="medium"
    >
      <Box
        alignSelf="center"
        gap="medium"
        pad={{ horizontal: "small", vertical: "medium" }}
        margin="medium"
      >
        <Grid
          columns={{ count: 3, size: "auto" }} // Ensure 3 cards per row
          gap="medium" // Adjust gap between cards to make them look less congested
          pad={{ horizontal: "small", vertical: "small" }}
        >
          {courses.map((course) => (
            <Card
              key={course.id}
              pad="small"
              margin="small"
              elevation="small"
              round="small"
              style={{
                border: "1px solid #E0E0E0",
                minWidth: "300px",
                maxWidth: "350px",
                minHeight: "250px",
              }}
            >
              <CardBody pad="small">
                <Box fill="vertical" justify="between" gap="small">
                  <Text size="small" color="dark-4">
                    {course.c_id}
                  </Text>

                  <Heading
                    level="3"
                    margin={{ top: "none", bottom: "small" }}
                    style={{
                      minHeight: "40px",
                    }}
                    color={selectedCourse === course.id ? "brand" : "dark-1"}
                  >
                    {course.name}
                  </Heading>
                  <Box gap="xsmall">
                    <Text size="small" color="dark-4">
                      Duration: <strong>{course.duration}</strong>
                    </Text>
                    <Text size="small" color="dark-4">
                      {course.isElearning === 2
                        ? "eLearning/ILT/VILT"
                        : course.isElearning
                          ? "eLearning"
                          : "ILT/VILT"}
                    </Text>
                  </Box>
                </Box>
              </CardBody>

              <CardFooter
                pad={{ horizontal: "small", vertical: "small" }}
                background="light-2"
                round={{ corner: "bottom", size: "small" }}
                style={{ borderTop: "1px solid #E0E0E0" }}
                direction="column"
              >
                {/* First Row: Course Outline and eLearning Outline */}
                <Box
                  direction="row"
                  gap="small"
                  fill="horizontal"
                  justify="center"
                >
                  {course.c_id === "H45ZMAAE" || course.c_id === "H45YZS" || course.c_id === "H45YYS" ? (
                    <Button
                      label="Contact us to enroll"
                      onClick={() => handleEnroll(course)}
                      primary
                      size="small"
                      style={{ minWidth: "120px" }}
                    />
                  ) : (
                    <Button
                      label="View course data sheet"
                      onClick={() => handleEnroll(course)}
                      primary
                      size="small"
                      style={{ minWidth: "120px" }}
                    />
                  )}
                  {course.isElearning === 2 && (
                    <Button
                      label="View eLearning data sheet"
                      onClick={() => handleelearningEnroll(course)}
                      secondary
                      size="small"
                      style={{ minWidth: "120px" }}
                    />
                  )}
                </Box>
              </CardFooter>
            </Card>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
